export default class Message {

  id!: number;
  userId!: number;
  orderSignerId!: number | null;
  orderId!: number;
  channel!: number;
  content!: string;
  supportCaseId!: number;
  contentType!: number;
  senderName!: string;
  createdTs!: number;
  updatedTs!: number;

  static CHANNEL_DEALER_CUSTOMER = 1;
  static CHANNEL_SUPPORT_DEALER = 2;
  static CHANNEL_SUPPORT_DEALER_CUSTOMER = 3;
  static CHANNEL_SCHEDULER_CUSTOMER = 4;
  static CHANNEL_SCHEDULER_NOTARY = 5;
  static CHANNEL_NOTARY_CUSTOMER = 6;

  static CONTENT_TYPE_TEXT = 1
  static CONTENT_TYPE_IMAGE = 2

  static getChannelMap() {
    return {
      [this.CHANNEL_DEALER_CUSTOMER]: 'Dealer - Customer',
      [this.CHANNEL_SUPPORT_DEALER]: 'Tech Support - Dealer',
      [this.CHANNEL_SUPPORT_DEALER_CUSTOMER]: 'Tech Support - Dealer - Customer',
      [this.CHANNEL_SCHEDULER_CUSTOMER]: 'Scheduler - Customer',
      [this.CHANNEL_SCHEDULER_NOTARY]: 'Notary - Scheduler',
      [this.CHANNEL_NOTARY_CUSTOMER]: 'Notary - Customer',
    };
  }
}